import React from 'react';
import { Container } from './ui/Container';
import { FileTextIcon, MoonIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-slate-950 text-center relative overflow-hidden" data-id="element-159">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-indigo-900 to-transparent opacity-50" data-id="element-160"></div>

      <Container data-id="element-161">
        <div className="max-w-3xl mx-auto" data-id="element-162">
          <div className="inline-flex items-center justify-center p-3 bg-indigo-900/20 rounded-full mb-8" data-id="element-163">
            <MoonIcon className="w-6 h-6 text-indigo-400" data-id="element-164" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-165">
            Presentando: <span className="text-indigo-400" data-id="element-166">RESET 3AM</span>
          </h2>

          <p className="text-xl text-slate-300 mb-12 leading-relaxed" data-id="element-167">
            Un PDF práctico (con hojas imprimibles) diseñado para un solo
            objetivo:
            <br className="hidden md:block" data-id="element-168" />
            <span className="text-white font-medium mt-2 block" data-id="element-169">
              Cuando despiertes entre 2–4AM y tu mente se prenda, tengas un plan
              de 15 minutos para volver a bajar.
            </span>
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-170">
            <div className="bg-slate-900/50 p-6 rounded-xl border border-slate-800" data-id="element-171">
              <h3 className="text-lg font-semibold text-white mb-2 flex items-center" data-id="element-172">
                <span className="w-2 h-2 bg-red-500 rounded-full mr-3" data-id="element-173"></span>
                Lo que NO es
              </h3>
              <ul className="space-y-2 text-slate-400" data-id="element-174">
                <li data-id="element-175">• No es "higiene del sueño" genérica</li>
                <li data-id="element-176">• No es una rutina de una hora</li>
                <li data-id="element-177">• No son promesas médicas falsas</li>
                <li data-id="element-178">• No es teoría infinita</li>
              </ul>
            </div>

            <div className="bg-indigo-950/20 p-6 rounded-xl border border-indigo-900/30" data-id="element-179">
              <h3 className="text-lg font-semibold text-white mb-2 flex items-center" data-id="element-180">
                <span className="w-2 h-2 bg-green-500 rounded-full mr-3" data-id="element-181"></span>
                Lo que SÍ es
              </h3>
              <ul className="space-y-2 text-slate-300" data-id="element-182">
                <li className="flex items-start" data-id="element-183">
                  <FileTextIcon className="w-4 h-4 mr-2 mt-1 text-indigo-400 shrink-0" data-id="element-184" />
                  <span data-id="element-185">Un guion paso a paso</span>
                </li>
                <li className="flex items-start" data-id="element-186">
                  <FileTextIcon className="w-4 h-4 mr-2 mt-1 text-indigo-400 shrink-0" data-id="element-187" />
                  <span data-id="element-188">Corto y secuenciado (15 min)</span>
                </li>
                <li className="flex items-start" data-id="element-189">
                  <FileTextIcon className="w-4 h-4 mr-2 mt-1 text-indigo-400 shrink-0" data-id="element-190" />
                  <span data-id="element-191">Imprimible (sin pantallas)</span>
                </li>
                <li className="flex items-start" data-id="element-192">
                  <FileTextIcon className="w-4 h-4 mr-2 mt-1 text-indigo-400 shrink-0" data-id="element-193" />
                  <span data-id="element-194">Directo al grano</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </section>;
}